import api from "./apiService";
import { TOKEN_OBTAIN, REGISTER_USER } from "./apiRoutes";
import { setAccessToken, setRefreshToken, clearTokens } from "./tokenService";

export async function registerUser(username, password) {
  const response = await api.post(REGISTER_USER, { username, password });
  const { access, refresh } = response.data;
  setAccessToken(access);
  setRefreshToken(refresh);
  return response.data;
}

export async function login(username, password) {
  const response = await api.post(TOKEN_OBTAIN, { username, password });
  const { access, refresh } = response.data;
  setAccessToken(access);
  setRefreshToken(refresh);
  return response.data;
}

export function logout() {
  clearTokens();
}
